import { PageHero, StatusPill, Reveal } from "@/components/site/Section";
import { INTEGRATIONS, IMG } from "@/data/content";

export default function Integrations() {
  const cats = [...new Set(INTEGRATIONS.map((i) => i.cat))];
  return (
    <div data-testid="integrations-page">
      <PageHero eyebrow="Integrations" title={<>Work With the Tools <span className="text-gradient">You Already Use</span></>}
        copy="Only supported integrations are marked Live. Demo integrations simulate connection and publishing while platform API approvals are completed. Planned integrations are marked Coming Soon. A CRM is not required." img={IMG.socialIcons} />
      <section className="py-20">
        <div className="container-x">
          <div className="flex flex-wrap gap-3 mb-10 text-xs">
            <span className="flex items-center gap-2"><StatusPill status="Live" /> Available now</span>
            <span className="flex items-center gap-2"><StatusPill status="Demo" /> Simulated in this release</span>
            <span className="flex items-center gap-2"><StatusPill status="Coming Soon" /> Planned</span>
          </div>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {INTEGRATIONS.map((x, i) => (
              <Reveal key={x.name} delay={(i % 4) * 0.05}>
                <div className="card-box p-6 lift h-full" data-testid={`integration-tile-${i}`}>
                  <div className="h-11 w-11 rounded-xl bg-brand flex items-center justify-center font-display font-bold text-white">{x.name[0]}</div>
                  <h3 className="mt-5 font-semibold">{x.name}</h3>
                  <div className="mt-3 flex items-center justify-between"><span className="text-xs text-muted-foreground">{x.cat}</span><StatusPill status={x.status} /></div>
                </div>
              </Reveal>
            ))}
          </div>
          <p className="mt-10 text-sm text-muted-foreground">Categories: {cats.join(" · ")}. You stay in control of content, approvals and publishing decisions. Advertising media spend is paid directly to ad platforms.</p>
        </div>
      </section>
    </div>
  );
}
